import React from 'react';
import { connect } from 'react-redux';
import DatasetCollectionDialogs from '../collections/containers/DatasetCollectionDialogs';
import DatasetReportDialogs from '../reports/containers/DatasetReportDialogs';
import DatasetFormDialogs from '../forms/components/DatasetFormDialogs';
import DatasetAttachmentDialogs from '../attachments/components/DatasetAttachmentDialogs';
import ValidateDataResultsDialog from '../data/components/ValidateDataResultsDialog';
import EditDictionaryDialog from '../dictionaries/containers/EditDictionaryDialog';
import DictionaryFieldDialog from '../fields/containers/DictionaryFieldDialog';
import DictionaryLookupDialog from '../lookups/containers/DictionaryLookupDialog';
import ShareDatasetDialog from '../sharing/containers/ShareDatasetDialog';
import DatasetSettingsDialogs from '../settings/containers/DatasetSettingsDialogs';
import DatasetConditionDialogs from '../conditions/containers/DatasetConditionDialogs';
import SaveDatasetDialog from './SaveDatasetDialog';
import DatasetDeletionDialog from './DatasetDeletionDialog';
import DatasourceDialog from '../datasource/containers/DatasourceDialog';
import DatasetNotificationCreateDialog from '../notifications/components/DatasetNotificationCreateDialog';

const DatasetDialogs = ({
  allowDelete,
  allowEditDatasource,
  allowEditDictionary,
  allowSave,
  allowShare,
  allowUpdateNotifications,
  allowValidate,
  allowViewField,
  allowViewLookup,
  theme,
}) => (
  <>
    <DatasetAttachmentDialogs theme={theme} />
    <DatasetCollectionDialogs theme={theme} />
    <DatasetConditionDialogs theme={theme} />
    <DatasetFormDialogs theme={theme} />
    <DatasetReportDialogs theme={theme} />
    <DatasetSettingsDialogs theme={theme} />
    {allowDelete && (<DatasetDeletionDialog theme={theme} />)}
    {allowEditDatasource && (<DatasourceDialog theme={theme} />)}
    {allowEditDictionary && (<EditDictionaryDialog theme={theme} />)}
    {allowSave && (<SaveDatasetDialog theme={theme} />)}
    {allowShare && (<ShareDatasetDialog theme={theme} />)}
    {allowUpdateNotifications && (<DatasetNotificationCreateDialog theme={theme} />)}
    {allowValidate && (<ValidateDataResultsDialog theme={theme} />)}
    {allowViewField && (<DictionaryFieldDialog theme={theme} />)}
    {allowViewLookup && (<DictionaryLookupDialog theme={theme} />)}
  </>
);

const mapStateToProps = ({
  auth: {
    role: {
      permissions: {
        datasets: {
          create, read, update, destroy, share, secure,
        },
      },
    },
  },
  datasetDataManagement: { validateDataResultsDialog },
  datasetDatasource: { activeDatasourceSetting },
  datasetNotifications: { datasetNotification },
  datasets: {
    activeDataset, deleteDatasetOpen, activeDictionaryEdit, lookups,
  },
  datasetUsers: { sharingDataset },
}) => ({
  allowDelete: deleteDatasetOpen && destroy,
  allowEditDatasource: activeDatasourceSetting.open && update,
  allowEditDictionary: activeDictionaryEdit.open && update,
  allowSave: activeDataset.open && create,
  allowShare: sharingDataset.open && (secure || share),
  allowUpdateNotifications: datasetNotification.open && read,
  allowValidate: validateDataResultsDialog.open && update,
  allowViewField: lookups.fieldsOpen && read,
  allowViewLookup: lookups.lookupsOpen && read,
});

export default connect(mapStateToProps)(DatasetDialogs);
